import React from 'react';
import './Badge.css';
import PropTypes from 'prop-types';
import { APP_TOOLTIP_ID } from '../tooltip/tooltipIds';

export default function Badge(props) {
  const { text, background, color, icon, width, tooltip, tooltipId, showInfoDot, size } = props;
  const anchorProps = tooltip
    ? {
        'data-tooltip-id': tooltipId ?? APP_TOOLTIP_ID,
        'data-tooltip-html': tooltip,
      }
    : {};

  return (
    <div
      className={`badge-container${size === 'sm' ? ' badge-container--sm' : ''}${tooltip ? ' badge-container--has-tooltip' : ''}`}
      style={{ background, width, color }}
      {...anchorProps}
    >
      {icon && <img loading="lazy" src={icon} className="badge-icon" alt="badge-check" />}
      <div className="badge-text" style={{ color }}>{text}</div>
      {showInfoDot && (
        <span className="badge-info-dot" style={{ backgroundColor: color }} aria-hidden="true" />
      )}
    </div>
  );
}


Badge.propTypes = {
    text: PropTypes.string.isRequired,
    background: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.string,
    width: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipId: PropTypes.string,
    showInfoDot: PropTypes.bool,
    size: PropTypes.oneOf(['sm']),
};
